import React from 'react';

interface AdminIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const AdminIcon: React.FC<AdminIconProps> = ({
  width = 12,
  height = 16,
  color = 'currentColor',
  className,
  style,
  title,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={title ? undefined : true}
    className={className}
    style={style}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M5 1.64706C5.91927 1.64706 6.66667 2.38566 6.66667 3.29412V4.94118H3.33333V3.29412C3.33333 2.38566 4.08073 1.64706 5 1.64706ZM1.66667 3.29412V4.94118C0.747396 4.94118 0 5.67978 0 6.58824V12.3529C0 13.2614 0.747396 14 1.66667 14H8.33333C9.2526 14 10 13.2614 10 12.3529V6.58824C10 5.67978 9.2526 4.94118 8.33333 4.94118V3.29412C8.33333 1.47463 6.84115 0 5 0C3.15885 0 1.66667 1.47463 1.66667 3.29412ZM5.625 8.44118V10.5C5.625 10.8423 5.34635 11.1176 5 11.1176C4.65365 11.1176 4.375 10.8423 4.375 10.5V8.44118C4.375 8.0989 4.65365 7.82353 5 7.82353C5.34635 7.82353 5.625 8.0989 5.625 8.44118Z"
      fill={color}
    />
  </svg>
);

export default AdminIcon;
